import { render, staticRenderFns } from "./CargaArticulos.vue?vue&type=template&id=30b51fe9&"
import script from "./CargaArticulos.vue?vue&type=script&lang=js&"
export * from "./CargaArticulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports